export const messages = {
  en: {
    reportFeeSummary: {
      queryCondition: 'Query Conditions',
      selectStartDate: 'Select start date',
      selectEndDate: 'Select end date',
      inputRoomNumber: 'Input room number',
      inputOwnerName: 'Input owner name',
      inputOwnerPhone: 'Input owner phone',
      selectFeeType: 'Select fee type',
      selectCommunity: 'Select community',
      feeSummaryTable: 'Fee Summary Table',
      updateDaily: 'Updated daily',
      totalRooms: 'Total Rooms',
      chargeRooms: 'Charge Rooms',
      arrearsRooms: 'Arrears Rooms',
      arrearsFormula: 'History Arrears + Current Arrears = Total Arrears',
      historyArrears: 'History Arrears',
      currentArrears: 'Current Arrears',
      totalArrears: 'Total Arrears',
      actualPaymentFormula: 'Arrears Recovery + Current Partial + Advance = Actual Payment',
      arrearsRecovery: 'Arrears Recovery',
      currentPartial: 'Current Partial',
      advancePayment: 'Advance Payment',
      actualPayment: 'Actual Payment',
      currentReceivable: 'Current Receivable',
      currentActual: 'Current Actual',
      roomChargeRate: 'Room Charge Rate',
      chargeRate: 'Charge Rate',
      clearanceRate: 'Clearance Rate',
      floorFeeSummary: 'Floor Fee Summary',
      configFeeSummary: 'Config Fee Summary',
      floorFeeRateStatistics: 'Floor Charge Rate Statistics',
      configFeeRateStatistics: 'Config Charge Rate Statistics',
      dateError: 'Start date must be earlier than end date',
      exportSuccess: 'Export success',
      exportFailed: 'Export failed',
      queryFailed: "Failed to query fee summary",
    }
  },
  zh: {
    reportFeeSummary: {
      queryCondition: '查询条件',
      selectStartDate: '请选择开始日期',
      selectEndDate: '请选择结束日期',
      inputRoomNumber: '请填写房屋编号',
      inputOwnerName: '请填写业主名称',
      inputOwnerPhone: '请填写业主手机号',
      selectFeeType: '请选择费用大类',
      selectCommunity: '请选择小区',
      feeSummaryTable: '费用汇总表',
      updateDaily: '按天更新',
      totalRooms: '总户数',
      chargeRooms: '收费户',
      arrearsRooms: '欠费户',
      arrearsFormula: '历史欠费+当期欠费=欠费',
      historyArrears: '历史欠费',
      currentArrears: '当期欠费',
      totalArrears: '总欠费',
      actualPaymentFormula: '欠费追回+当期部分+预交=实缴',
      arrearsRecovery: '欠费追回',
      currentPartial: '当期部分',
      advancePayment: '预交',
      actualPayment: '实缴',
      currentReceivable: '当期应收',
      currentActual: '当期实收',
      roomChargeRate: '户收费率',
      chargeRate: '收费率',
      clearanceRate: '清缴率',
      floorFeeSummary: '楼栋费用汇总',
      configFeeSummary: '费用项汇总',
      floorFeeRateStatistics: '楼栋收费率统计',
      configFeeRateStatistics: '费用项收费率统计',
      dateError: '开始日期必须早于结束日期',
      exportSuccess: '导出成功',
      exportFailed: '导出失败',
      queryFailed: "查询费用汇总失败",
    }
  }
}